export interface ICategoryDto {
    categoryId: string | null;
    color: string | null;
    name: string | null;
    nProducts: string | null
}

export class CategoryDto implements ICategoryDto {
    public categoryId: string | null;
    public color: string | null;
    public name: string | null;
    public nProducts: string | null;

    constructor(categoryId: string | null, color: string | null, name: string | null, nProducts: string | null) {
        this.categoryId = categoryId;
        this.color = color;
        this.name = name;
        this.nProducts = nProducts;
    }
}